import { render } from "./vminipluswecomadd.vue?vue&type=template&id=6f9b1a64&scoped=true"
import script from "./vminipluswecomadd.vue?vue&type=script&lang=js"
export * from "./vminipluswecomadd.vue?vue&type=script&lang=js"

import "./vminipluswecomadd.vue?vue&type=style&index=0&id=6f9b1a64&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9b1a64"]])

export default __exports__